import * as types from '../actionTypes';
import DAWAResource from "../../services/DAWAResource";

export function searchUserAddress(searchParams) {
    return (dispatch) => {
        return DAWAResource.addressSearch(
            searchParams.municipalityId,
            searchParams.regionId,
            searchParams.searchString
        )
            .then((addresses) => {
                dispatch(searchUserAddressSuccess(addresses));
            })
            .catch(err => {
                throw  err;
            });
    }
}

export function getUserAddressDetails(addressId) {
    return (dispatch) => DAWAResource.get('adresser', addressId)
        .then((details) => {
            dispatch(getUserAddressDetailsSuccess(details));
        })
        .catch(err => {
            throw  err;
        });
}

export function clearUserAddressData(type) {
    return (dispatch) => {
        if(type === 'regions') {
            dispatch(clearUserAddressSearchResult());
            dispatch(clearUserCityInformation());
            dispatch(clearMunicipalityInformation());
        } else if(type === 'address') {
            dispatch(clearUserAddressInformation);
            dispatch(clearUserAddressSearchResult());
            dispatch(clearUserCityInformation());
        } else {
            dispatch(clearUserAddressSearchResult());
            dispatch(clearUserCityInformation());
        }
    }
}

export function searchUserAddressSuccess(addresses) {
    return {type: types.SEARCH_USER_PROFILE_ADDRESS_SUCCESS, addresses};
}

export function getUserAddressDetailsSuccess(details) {
    return {type: types.GET_USER_PROFILE_ADDRESS_DETAILS_SUCCESS, details};
}

export function clearUserAddressSearchResult() {
    return {type: types.CLEAR_USER_PROFILE_ADDRESS_SEARCH_RESULT};
}

export function clearUserCityInformation() {
    return {type: types.CLEAR_USER_PROFILE_CITY_INFORMATION};
}

export function clearMunicipalityInformation() {
    return {type: types.CLEAR_USER_PROFILE_MUNICIPALITY_ID};
}

export function clearUserAddressInformation() {
    return {type: types.CLEAR_USER_PROFILE_ADDRESS_ID};
}


// WEBPACK FOOTER //
// ./web/src/actions/user/userAddressSearchActions.js